import { render, staticRenderFns } from "./m-taxbill-details.vue?vue&type=template&id=1e2905a6&scoped=true&lang=pug"
import script from "./m-taxbill-details.vue?vue&type=script&lang=js"
export * from "./m-taxbill-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2905a6",
  null
  
)

export default component.exports